import type { RequestsVisibility } from "@/queries/confirm-association/confirm-association.api";

export const REQUESTS_VISIBILITY_LABELS: Record<RequestsVisibility, string> = {
  OWN: "Solo puede visualizar sus solicitudes.",
  ALL: "Puede visualizar todas las solicitudes, incluyendo las iniciadas por el titular u otros asociados.",
};

/**
 * Etiqueta del alcance de visualización de solicitudes, o `undefined` cuando el
 * backend no envía el dato.
 */
export const getRequestsVisibilityLabel = (
  visibility?: RequestsVisibility | null,
) => (visibility ? REQUESTS_VISIBILITY_LABELS[visibility] : undefined);
